import {
  DashboardInput
}  from 'src/services/graphql/Models';
import Layouts from './Layouts';
import { Parsable } from 'src/shared/utility';
import Layout from './Layout';

export default class Dashboard implements DashboardInput, Parsable {
  clientId: string;
  typedId: string;
  icon?: string | null;
  name: string;
  layout?: Layouts | null;
  
  constructor ( from: any ) { 
    this.clientId = from.clientId;
    this.typedId = from.typedId;
    this.icon = from.icon;
    this.name = from.name;
    this.layout = new Layouts(from.layout);
  }

  parseAbsolute() {
    return {
      clientId: this.clientId,
      typedId: this.typedId,
      icon: this.icon,
      name: this.name,
      layout: this.layout.parseAbsolute()
    };
  }

  eachCharts(charts: string[], layouts: Layout[]) {
    return layouts.filter(layout => 
      !charts.some(chart => chart === layout.i)
    ).map(o => o.i);
    
  }

  getCharts() {
    let result = [];
    result = result.concat(this.eachCharts(result, this.layout.lg));
    result = result.concat(this.eachCharts(result, this.layout.md));
    result = result.concat(this.eachCharts(result, this.layout.sm));
    result = result.concat(this.eachCharts(result, this.layout.xs));
    return result;
  }

  eachUpdateChart(values: string[], layouts: Layout[]) {
    return (layouts || [])
      .filter(layout => 
        values.some(value => value === layout.i)
      )
      .concat(
        values.filter(value => 
          layouts.every(layout => layout.i !== value)
        ).map(value => {
          let layoutindex = layouts.findIndex(layout => layout.i === value);
          if (layoutindex < 0) {
            return new Layout({
              i: value,
              x: 0,
              y: 0,
              h: 10,
              w: 10
            });
          } else {
            return layouts[layoutindex];
          }
        })
      );
  }

  updateChart(values: string[]) {
    let updater = this.eachUpdateChart.bind(this, values);
    let lg = updater(this.layout.lg);
    let md = updater(this.layout.md);
    let sm = updater(this.layout.sm);
    let xs = updater(this.layout.xs);

    return {lg, md, sm, xs};
  }
}


// WEBPACK FOOTER //
// ./src/stores/application/classes/Dashboard.ts